import React from "react";
import ERP from "./Times/ERP";
import Gerencia from "./Times/Gerencia";
import Labs from "./Times/Labs";
import Operacao from "./Times/Operacao";
import Sistemas from "./Times/Sistemas";
import Suporte from "./Times/Suporte";
import Atendimento from "./Times/Atendimento";
import Background from "./Bckground";

import Seguranca from "./Times/Seguranca";

const Times = () => {
  return (
    <main>
      {" "}
      {/* <Background /> */}
      <section className="geral">
        <Gerencia />
        <ERP />
        <Labs />
        <Operacao />
        <Sistemas />
        <Suporte />
        <Atendimento />
        {/* <Seguranca /> */}
      </section>
    </main>
  );
};

export default Times;
